import type { Template } from "@/types";

export const PO_03_H1_V2: Template[] = [
    {
        id: "po-03-h1v2-01",
        name: "PO 01 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_01.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 58, y: 219, width: 587, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 653, y: 219, width: 290, height: 390, rotation: 0, imageRotation: 0 },
            { id: "3", x: 951, y: 219, width: 290, height: 390, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-02",
        name: "PO 02 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_02.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 58, y: 219, width: 290, height: 390, rotation: 0, imageRotation: 0 },
            { id: "2", x: 356, y: 219, width: 588, height: 390, rotation: 0, imageRotation: 0 },
            { id: "3", x: 952, y: 219, width: 290, height: 390, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-03",
        name: "PO 03 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_03.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 77, y: 250, width: 245, height: 326, rotation: 0, imageRotation: 0 },
            { id: "2", x: 329, y: 250, width: 244, height: 326, rotation: 0, imageRotation: 0 },
            { id: "3", x: 718, y: 250, width: 510, height: 326, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-04",
        name: "PO 04 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_04.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 72, y: 75, width: 224, height: 335, rotation: 0, imageRotation: 0 },
            { id: "2", x: 72, y: 418, width: 224, height: 335, rotation: 0, imageRotation: 0 },
            { id: "3", x: 304, y: 75, width: 921, height: 678, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-05",
        name: "PO 05 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_05.png",
        size: [1298, 827],
        style: {},
        slots: [         
            { id: "1", x: 131, y: 142, width: 201, height: 268, rotation: 0, imageRotation: 0 },
            { id: "2", x: 131, y: 418, width: 201, height: 268, rotation: 0, imageRotation: 0 },
            { id: "3", x: 340, y: 142, width: 827, height: 544, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-06",
        name: "PO 06 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_06.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 213, y: 75, width: 224, height: 335, rotation: 0, imageRotation: 0 },
            { id: "2", x: 213, y: 417, width: 224, height: 335, rotation: 0, imageRotation: 0 },
            { id: "3", x: 689, y: 233, width: 568, height: 361, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-07",
        name: "PO 07 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_07.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 74, y: 75, width: 921, height: 677, rotation: 0, imageRotation: 0 },
            { id: "2", x: 1003, y: 75, width: 224, height: 335, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1003, y: 418, width: 224, height: 334, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-08",
        name: "PO 08 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_08.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 132, y: 142, width: 827, height: 544, rotation: 0, imageRotation: 0 },
            { id: "2", x: 967, y: 142, width: 201, height: 268, rotation: 0, imageRotation: 0 },
            { id: "3", x: 967, y: 418, width: 201, height: 268, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "po-03-h1v2-09",
        name: "PO 09 - H1V2",
        albumType: "PO",
        thumbnail: "/thumbnails/PO/po-03-h1_v2_09.png",
        size: [1298, 827],
        style: {},
        slots: [
            { id: "1", x: 69, y: 250, width: 510, height: 326, rotation: 0, imageRotation: 0 },
            { id: "2", x: 726, y: 250, width: 244, height: 326, rotation: 0, imageRotation: 0 },
            { id: "3", x: 978, y: 250, width: 244, height: 326, rotation: 0, imageRotation: 0 }
        ],
    }
];